import React, { useState } from 'react';
import MaterialTable from 'material-table';
import {Container} from '@material-ui/core';

const dataList = [
  { id: 1, name: "Apple", cat:  'Fruit', price: 42, available: "Yes" },
  { id: 2, name: "Banana", cat: 'Fruit', price: 50, available: "No"},
  { id: 3, name: "Grapes", cat: 'Fruit', price: 60, available: "Yes"},
  { id: 4, name: "Patato", cat: 'Vegitable', price: 20, available: "No" },
]

const AddProduct = ()=> {

  const [data, setData] = useState(dataList)
  const columns = [
    { title: "ID", field: "id", editable: false },
    { title: "Name", field: "name" },
    { title: "Category", field: "cat" },
    { title: "Price", field: 'price', },
    { title: "Avaiable", field: "available", }
  ]


  return (
    <Container maxWidth="md" fixed>
      <MaterialTable
        title="Products"
        data={data}
        columns={columns}
        editable={{
          onRowAdd: (newRow) => new Promise((resolve, reject) => {
            const updatedRows = [...data, { id: Math.floor(Math.random() * 100), ...newRow }]
            setTimeout(() => {
              setData(updatedRows)
              resolve()
            }, 2000)
          }),
          onRowDelete: selectedRow => new Promise((resolve, reject) => {
            const index = selectedRow.tableData.id;
            const updatedRows = [...data]
            updatedRows.splice(index, 1)
            setTimeout(() => {
              setData(updatedRows)
              resolve()
            }, 2000)
          }),
          onRowUpdate:(updatedRow,oldRow)=>new Promise((resolve,reject)=>{
            const index=oldRow.tableData.id;
            const updatedRows=[...data]
            updatedRows[index]=updatedRow
            setTimeout(() => {
              setData(updatedRows)
              resolve()
            }, 2000)
          }),
          //onBulkUpdate:selectedRows=>new Promise((resolve,reject)=>{
            //const rows=Object.values(selectedRows)
            //const updatedRows=[...data]
            //let index;
            //rows.map(emp=>{
              // index=emp.oldData.tableData.id
              // updatedRows[index]=emp.newData
           // })
           // setTimeout(()=>{
             // setData(updatedRows)
              //resolve()
            //},2000)
          
         // })

        }}
        options={{
          actionsColumnIndex: -1, addRowPosition: "first"
        }}
      />
    </Container>
  );
}

export default AddProduct;